import { z } from "zod";

const translationPath = "page.register.roles.errors.";

const listCategorySchema = z
  .object({
    id: z.string(),
    name: z.string(),
    code: z.union([z.string(), z.number()]).nullish(),
  })
  .nullish()
  .refine((value) => !!value, {
    message: translationPath + "list_category",
  });

export const profileListCategorySchema = z.object({
  listCategory: listCategorySchema,
});

export type TProfileListCategoryForm = z.infer<
  typeof profileListCategorySchema
>;
